import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Box2, Box3, Vector2, Vector3 } from "three";
import { v3 } from "oc-threejs/short3";
import * as Maths3 from "oc-threejs/Maths3";
import { Fundament3d } from "../arrangement3d/Fundament3d";

export class Fundament extends Jaco {
  static CLASS_NAME = "Fundament";

  points: Vector2[] = [];
  bodenAbstand = 0;
  tiefe = 0;

  update3d() {
    super.update3d();
  }

  getBox(): Box3 {
    const b2 = new Box2().setFromPoints(this.points);
    const b3 = new Box3(
      Maths3.v2To3xz(b2.min, this.bodenAbstand - this.tiefe),
      Maths3.v2To3xz(b2.max, this.bodenAbstand)
    );
    return b3;
  }

  /**
   * gibt die Size im eigenen lokalen Koordinatensystem zurück
   * @returns {THREE.Vector3}
   */
  getSize(): Vector3 {
    return this.getBox().getSize(v3());
  }

  createJaco3d() {
    return new Fundament3d(this);
  }
}
